import { render, staticRenderFns } from "./LiveAttendeeFAQ.vue?vue&type=template&id=206a0cc4&"
import script from "./LiveAttendeeFAQ.vue?vue&type=script&lang=js&"
export * from "./LiveAttendeeFAQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports